let newFn = () => {
  console.log(`Hello`);
};
newFn();